import { getVideoGallery } from '../Service/Api';
import { Link } from 'react-router-dom';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import LazyLoad from 'react-lazyload';
import React, { useState, useEffect } from 'react';

const VideoGallery = () => {
    useEffect(() => {
        document.title = 'Video Gallery -  St Peters convent School Faridabad Haryana';
    }, []);

    const [data, setData] = useState([]);
    const [filterData, setFilteredData] = useState([]);
    const [selectedYear, setSelectedYear] = useState("All");
    const [yearRanges, setYearRanges] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const galleryData = await getVideoGallery();

            // 🔥 Sort by latest date FIRST
            galleryData.sort((a, b) => new Date(b.date) - new Date(a.date));

            setData(galleryData);

            // Extract unique years
            const uniqueYears = Array.from(
                new Set(
                    galleryData.flatMap((item) => {
                        if (item.date) {
                            const year = new Date(item.date).getFullYear();
                            return [year];
                        } else {
                            return [];
                        }
                    })
                )
            );

            const uniqueYearRanges = uniqueYears.map(year => `${year}`);

            // Sort year dropdown newest → oldest
            uniqueYearRanges.sort((a, b) => b - a);

            setYearRanges(uniqueYearRanges);
        };

        fetchData();
    }, []);

    useEffect(() => {
        let filteredData = data;

        if (selectedYear !== "All") {
            filteredData = filteredData.filter((item) => {
                if (item.date) {
                    const year = new Date(item.date).getFullYear();
                    return parseInt(selectedYear) === year;
                } else {
                    return false;
                }
            });
        }

        // 🔥 Sort filtered data newest → oldest
        filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));

        setFilteredData(filteredData);
    }, [selectedYear, data]);

    return (
        <>
            <Header />

            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>
                    <li>  Gallery  </li>
                    <li>  Video Gallery  </li>
                </ul>
            </div>

            <div className="innersec">
                <div className='container'>
                    <div className='row'>
                        <div className="col-lg-12">
                            <div className="chooseyear">
                                <select
                                    id="chooseddlYear"
                                    value={selectedYear}
                                    onChange={(e) => setSelectedYear(e.target.value)}
                                    className="yearSelection"
                                >
                                    <option value="All">All</option>
                                    {yearRanges.map((yr) => (
                                        <option key={yr} value={yr}>{yr}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="clr"></div>

                            <div className="row">
                                {filterData.length > 0 && filterData.map((item, index) => (
                                    <div
                                        className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch"
                                        key={index}
                                    >
                                        <div className="video-gallery">

                                            {/* If no attachments → Show Youtube iframe */}
                                            {item?.attachments.length === 0 ? (
                                                <>
                                                    <iframe
                                                        width="100%"
                                                        height="200"
                                                        src={item.videoUrl}
                                                        title="YouTube video player"
                                                        frameBorder="0"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                        allowFullScreen
                                                    ></iframe>

                                                    <div>
                                                        <h3>{item.title}</h3>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <Link to={item.videoUrl} target="_blank">
                                                        <LazyLoad>
                                                            {item?.attachments.length > 0 ? (
                                                                <img
                                                                    src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item?.attachments[0]}`}
                                                                    alt="Gallery"
                                                                    className="img-fluid"
                                                                />
                                                            ) : (
                                                                <img
                                                                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/demo.jpg"
                                                                    alt="Gallery Placeholder"
                                                                    className="img-fluid"
                                                                />
                                                            )}
                                                        </LazyLoad>

                                                        <div>
                                                            <h3>{item.title}</h3>
                                                        </div>
                                                    </Link>
                                                </>
                                            )}

                                        </div>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default VideoGallery;
